import { useSelector } from 'react-redux';
import buildCsv from './buildCsv';
import { currentMetricsMetaSelector, selectedCustomerNameSelector } from '@store/common/selectors';
import { useAtomValue } from 'jotai';
import { exportDataAtom } from './atom';

function useExport({ config }) {
  const customerName = useSelector(selectedCustomerNameSelector);
  const currentMetricsMeta = useSelector(currentMetricsMetaSelector);
  const data = useAtomValue(exportDataAtom);

  const triggerDownload = () => {
    buildCsv({ config, data, customerName, metricList: currentMetricsMeta });
  };

  return { data, triggerDownload };
}

export default useExport;
